import { reduce } from "et3-type-guards";
import React from "react";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserAdvancedStore from "../../../stores/user-store/advanced-store";
import UserAdvancedForm from "./user-advanced-form";
import UserAdvancedData from "./user-advanced-data/index";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Section from "../../../core/et3-section";
import { ADVANCED_SEARCH_SECTION_ID } from "./user-advanced-data/user-advanced-data-constants";

const UserAdvanced = withLiteObserverAndTheme(() => {
  const location = useLocation();
  const hasResults = getUserAdvancedStore().userIDs.get().length > 0;
  const currentUserId = getUserAdvancedStore().currentUserId.get();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_ADVANCED", "USER_ADVANCED");
    getUserAdvancedStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("ADVANCED_MODE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Et3Section
        titleKey={"SEARCH"}
        summary={hasResults ? `#${currentUserId}` : ""}
        count={0}
        sectionId={ADVANCED_SEARCH_SECTION_ID}
        defaultOpen={!hasResults}
      >
        <UserAdvancedForm />
      </Et3Section>
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <UserAdvancedData />
    </ET3PageDiv>
  );
});
export default UserAdvanced;
